__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-01-1788265794-stable-dev/";